import React, { useEffect, useState } from 'react';
import { useAuth } from './AuthProvider';
import { BrowserRouter as Router, Route, Routes, Navigate } from 'react-router-dom';
import Home from './components/Home';
import Interviews from './components/Interviews';
import Layout from './components/Layout';
import Account from './components/Account';
import Interview from './components/Interview';
import InterviewDetails from './components/InterviewDetails';
import './App.css';
import './styles/styles.css';
import PrivateRoute from './components/PrivateRoute';
import Feedback from './components/Feedback';
import Questions from './components/Questions';
import Pricing from './components/Pricing';
import NavBar from './components/NavBar';

function App() {
  const { user, loading } = useAuth();
  const [userPlan, setUserPlan] = useState('free');
  const [isMobile, setIsMobile] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchUserPlan = async () => {
      if (user) {
        try {
          const token = await user.getIdToken();
          const response = await fetch('http://localhost:4242/get-user-plan', {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          });
          
          if (!response.ok) {
            const responseText = await response.text();
            console.error('Server response:', responseText);
            throw new Error(`HTTP error! status: ${response.status}`);
          }
          
          const contentType = response.headers.get("content-type");
          if (!contentType || !contentType.includes("application/json")) {
            const responseText = await response.text();
            console.error('Unexpected content type:', contentType);
            console.error('Server response:', responseText);
            throw new TypeError("Oops, we haven't got JSON!");
          }
          
          const data = await response.json();
          setUserPlan(data.plan);
        } catch (error) {
          console.error("Error fetching user plan:", error);
          console.error("Response details:", error.message);
          setError("Failed to fetch user plan. Please try again later.");
        }
      }
    };

    fetchUserPlan();
  }, [user]);

  useEffect(() => {
    // Function to check if the device is mobile
    const checkIfMobile = () => {
      const userAgent = navigator.userAgent || navigator.vendor || window.opera;
      // Simple regex to check for mobile devices
      return /android|iphone|ipad|iPod|blackberry|iemobile|opera mini/i.test(userAgent);
    };

    setIsMobile(checkIfMobile());

    // Optionally, you can add an event listener to handle window resizing
    const handleResize = () => {
      setIsMobile(checkIfMobile());
    };

    window.addEventListener('resize', handleResize);

    // Cleanup the event listener on component unmount
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  if (loading) {
    return <div>Loading...</div>;
  }

  if (isMobile) {
    return (
      <div style={styles.mobileContainer}>
        <p style={styles.mobileText}>pmMocks does not support mobile usage yet.</p>
      </div>
    );
  }

  return (
    <Router>
      <Layout>
        <NavBar />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/interviews" element={<PrivateRoute><Interviews /></PrivateRoute>} />
          <Route path="/account" element={<Account />} />
          <Route path="/interview/:interviewId" element={<Interview />} />
          <Route path="/interview-details/:interviewId" element={<InterviewDetails />} />
          <Route path="/feedback/:interviewId" element={<Feedback />} />
          <Route path="/questions" element={<Questions />} />
          <Route path="/pricing" element={<Pricing />} />
        </Routes>
      </Layout>
    </Router>
  );
}

const styles = {
  mobileContainer: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    height: '100vh',
    backgroundColor: '#FFFFFF',
    textAlign: 'center',
    padding: '20px',
  },
  mobileText: {
    fontSize: '1.5rem',
    color: '#000000',
  },
};

export default App;